import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Modal from "../../Components/Modal/Modal";
import {
  addRemoveFavouriteTeacher,
  blockUnblockTeacher,
} from "../../redux/college/college.actions";
import ConfirmButton from "../Buttons/ConfirmButton";
import CancelButton from "../Buttons/CancelButton";
import { getTeacherProfileName, getTeacherType } from "../../Helper";
import "./SearchCard.css";
import DatePicker from "react-datepicker";
import CheckableButton from "../CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import FormField from "../FormField/FormField";
import FormDropdown from "../FormField/FormDropdown";
import { notify } from "react-notify-toast";
import { Help, Schedule } from "@material-ui/icons";
import { API } from "../../API";
import { CalendarMonthRounded, ScheduleSendRounded, EventAvailable, EventBusy } from "@mui/icons-material";
import ReactTooltip from 'react-tooltip'
import Auth from "../../Auth/Auth";

function SearchCard(props) {
  const {
    user,
    isFaved,
    isBlocked,
    showBookTeacherButton,
    showInterviewButton,
    interviewRequested,
    campuses,
    interviewTime,
    setRefresh,
    providerUser,
    currentFilter,
    rowsPerPage,
    pageNum,
    onSearchTeacher
  } = props;
  const previousInterviewScheduleInfo = JSON.parse(
    localStorage.getItem("interviewScheduleInfo")
  );
  const [showModal, setShowModal] = useState(false);
  const [isRequestToViewCalendar, setIsRequestToViewCalendar] = useState(false);
  const [showInterviewModal, setShowInterviewModal] = useState(false);
  const [preferredTime1, setPreferredTime1] = useState(
    Date.parse(previousInterviewScheduleInfo?.preferredTime1) || new Date()
  );
  const [preferredLocation1, setPreferredLocation1] = useState(
    previousInterviewScheduleInfo?.preferredLocation1 || "online"
  );
  const [meetingLink1, setMeetingLink1] = useState(
    previousInterviewScheduleInfo?.meetingLink1 || ""
  );
  const [campus1, setCampus1] = useState(
    previousInterviewScheduleInfo?.campus1 || ""
  );
  const [preferredTime2, setPreferredTime2] = useState(
    Date.parse(previousInterviewScheduleInfo?.preferredTime2) || new Date()
  );
  const [preferredLocation2, setPreferredLocation2] = useState(
    previousInterviewScheduleInfo?.preferredLocation2 || "online"
  );
  const [meetingLink2, setMeetingLink2] = useState(
    previousInterviewScheduleInfo?.meetingLink2 || ""
  );
  const [campus2, setCampus2] = useState(
    previousInterviewScheduleInfo?.campus2 || ""
  );
  const [preferredTime3, setPreferredTime3] = useState(
    Date.parse(previousInterviewScheduleInfo?.preferredTime3) || ""
  );
  const [preferredLocation3, setPreferredLocation3] = useState(
    previousInterviewScheduleInfo?.preferredLocation3 || ""
  );
  const [meetingLink3, setMeetingLink3] = useState(
    previousInterviewScheduleInfo?.meetingLink3 || ""
  );
  const [campus3, setCampus3] = useState(
    previousInterviewScheduleInfo?.campus3 || ""
  );
  const confirmedInterviewTime = interviewTime?.find(
    (schedule) => schedule.status === "selected"
  );

  const toggleFave = () => {
    props.addRemoveFavouriteTeacher(user._id);
  };

  const toggleBlock = () => {
    setShowModal(true);
  };

  const closeModal = (e) => {
    setShowModal(false);
  };

  const handleOpenRequestToViewCalendar = () => {
    if (user?.is_request_view === "requested") return;
    if (user?.is_request_view === "accepted") {
      props.history.push(`/ViewCalendar?teacher_id=${user?._id}`);
    } else {
      setIsRequestToViewCalendar(true);
    }
  };

  const handleCloseRequestToViewCalendar = () => {
    setIsRequestToViewCalendar(false);
  };

  const handleRequestToViewCalendar = async () => {
    try {
      const role = Auth.verifyUserRole()
      const customerId = role === "customer" ? providerUser?.customer_id : providerUser?.personnel_id;
      await API.requestToViewCalendarV2({
        requested_by_id: customerId,
        request_role: role,
        teacher_id: user?._id,
      });
      notify.show(
        `Your request has been sent to teacher. You will receive an email with their response`
      );
      setRefresh(preState => !preState)
      setIsRequestToViewCalendar(false);
      onSearchTeacher(currentFilter, rowsPerPage, pageNum)
    } catch (error) {
      notify.show(error?.response?.data.message);
      setIsRequestToViewCalendar(false);
    }
  };

  const handleBlockTeacher = (e) => {
    props.blockUnblockTeacher(user._id, isBlocked);
    setShowModal(false);
  };

  const blockButton = () => {
    return isBlocked ? (
      <Icon
        name="ban"
        className="search-card-remove"
        color="red"
        title="Remove from block list"
        onClick={toggleBlock}
      />
    ) : (
      <Icon
        name="ban"
        className="search-card-remove"
        title="Add to block list"
        onClick={toggleBlock}
      />
    );
  };

  const favHeart = () => {
    return isFaved ? (
      <Icon
        name="heart"
        // size="big"
        color="black"
        className="search-card-heart"
        onClick={toggleFave}
        title="Remove from Favourites"
      />
    ) : (
      <Icon
        name="heart outline"
        // size="big"
        color="grey"
        className="search-card-heart"
        onClick={toggleFave}
        title="Add to Favourites"
      />
    );
  };

  let quals = user.qualifications || [];
  if (user.vet_training_quals) {
    quals = quals.concat(user.vet_training_quals);
  }
  if (user.vet_industry_quals) {
    quals = quals.concat(user.vet_industry_quals);
  }

  quals = quals.filter((qual) => {
    return qual.show_in_search;
  });

  const bookTeacher = () => {
    props.history.push("/CollegeCalendar", {
      teacher_name: {
        first_name: user.first_name,
        last_name: user.last_name,
        preferred_name: user.preferred_name,
      },
      teacher_avatar: user.img_url,
      teacher_id: user._id,
      show_modal: true,
    });
  };

  const requestInterview = () => {
    // edit with params etc where necessary
    const fields = [
      "preferredTime1",
      "location_online1",
      "location_on_campus1",
      "meeting_link1",
      "campus1",
      "preferredTime2",
      "location_online2",
      "location_on_campus2",
      "meeting_link2",
      "campus2",
      "preferredTime3",
      "location_online3",
      "location_on_campus3",
      "meeting_link3",
      "campus3",
    ];
    let errors = false;
    for (let field of fields) {
      const input = document.getElementById(field);
      if (input !== null && !input.reportValidity()) {
        errors = true;
        break;
      }
    }
    if (errors) {
      notify.show("You are missing one or more field(s)!");
    }

    if (!errors) {
      let interviewScheduleInfo = {
        preferredTime1,
        preferredLocation1,
        meetingLink1,
        campus1,
        preferredTime2,
        preferredLocation2,
        meetingLink2,
        campus2,
        preferredTime3,
        preferredLocation3,
        meetingLink3,
        campus3,
      };
      localStorage.setItem(
        "interviewScheduleInfo",
        JSON.stringify(interviewScheduleInfo)
      );
      // console.log(interviewScheduleInfo)
      // Note: requestInterview function is in ViewApplicants.js and ViewApplicantsAdmin.js
      props.requestInterviewWithScheduler(user, interviewScheduleInfo);
      setShowInterviewModal(false);
    }
  };

  return (
    <div className="search-card-outer">
      <div className="search-card-container">
        <div className="search-container-inner">
          <div className="search-card-avatar-container">
            <img
              src={user.img_url || "../../assets/img/avatar.png"}
              alt={user.first_name}
              className="search-card-avatar"
            />
          </div>
          <h2 className="search-card-name text-center">
            {getTeacherProfileName(user)}
          </h2>
          <h3 className="search-card-subtitle">{getTeacherType(user)}</h3>
          <hr className="search-card-hr" />
          <ul className="search-card-quals">
            {quals.map((qual, index) => {
              return (
                <li key={index}>
                  {qual.degree} {qual.award_name}
                </li>
              );
            })}
          </ul>
          <div className="search-card-buttons">
            {/* <div className="col-6">
              <ConfirmButton onClick={viewProfile}>View Profile</ConfirmButton>

            </div>
            <div className="col-6">
              <ConfirmButton onClick={bookTeacher}>Book Me</ConfirmButton>
            </div> */}
            {showBookTeacherButton && (
              <ConfirmButton
                onClick={bookTeacher}
                // disabled
                className="search-card-book-me"
              >
                Book Me
              </ConfirmButton>
            )}
            {showInterviewButton && (
              <ConfirmButton
                onClick={() => setShowInterviewModal(true)}
                disabled={
                  interviewRequested &&
                  !confirmedInterviewTime &&
                  !props.isAdmin
                }
              >
                {interviewRequested
                  ? confirmedInterviewTime
                    ? "Confirmed Interview Time"
                    : props.isAdmin
                    ? "Requested Interview Time"
                    : "Interview Requested"
                  : "Request Interview"}
              </ConfirmButton>
            )}
          </div>
        </div>
      </div>
      {favHeart()}
      <Link
        to={"/NavigateToShareProfile?id=" + user._id}
        className="search-card-profile"
        target="blank"
      >
        <Icon
          name="user circle"
          // size="huge"
          // onClick={viewProfile}
          title="View Profile"
        />
      </Link>
      {blockButton()}
      {/* <img
        
        className="search-card-help-button"
        src=
        {
          user?.is_request_view === "accepted"
            ? "/assets/img/ic_calendar_approved.png"
            : user?.is_request_view === "requested"
            ? "/assets/img/request_calendar_pending.png"
            : "/assets/img/ic_calendar_request.png"
        }
        alt="icon"
      /> */}
      <div onClick={handleOpenRequestToViewCalendar} className="search-card-help-button">
      {
          user?.is_request_view === "accepted"
            ? <EventAvailable />
            : user?.is_request_view === "requested"
            ? <ScheduleSendRounded  data-for="wwcc-hover" data-tip="Calendar requested"/>
            : <CalendarMonthRounded />
      }
            <ReactTooltip
                backgroundColor="rgb(47, 224, 222)"
                id="wwcc-hover"
                effect="solid"
          />
      </div>
      <Modal
        className="confirm-delete"
        header={`You are sending a request to view ${getTeacherProfileName(
          user
        )}'s calendar`}
        show={isRequestToViewCalendar}
        onClose={handleCloseRequestToViewCalendar}
      >
        <div className="row flex justify-center m-0">
          <div className="col-md-6 padding-for-mobile">
            <ConfirmButton type="button" onClick={handleRequestToViewCalendar}>
              Submit
            </ConfirmButton>
          </div>
        </div>
      </Modal>
      <Modal
        className="confirm-delete"
        header={
          isBlocked
            ? "Do you wish to unblock this Teacher ?"
            : "Do you wish to block this Teacher ?"
        }
        show={showModal}
        onClose={closeModal}
      >
        <div className="row m-0">
          <div className="col-md-6">
            <CancelButton type="button" onClick={closeModal}>
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6 padding-for-mobile">
            <ConfirmButton type="button" onClick={handleBlockTeacher}>
              Yes and Proceed
            </ConfirmButton>
          </div>
        </div>
      </Modal>

      <Modal
        className="schedule-interview-modal"
        header={
          interviewTime
            ? confirmedInterviewTime
              ? "Confirmed Interview Time"
              : "Requested Interview Time"
            : "Schedule Interview"
        }
        show={showInterviewModal}
        onClose={() => setShowInterviewModal(false)}
      >
        {interviewTime ? (
          confirmedInterviewTime ? (
            <div className="row m-0">
              <CheckableButton className="w-100 mb-3 pl-5 p-2" checked={true}>
                {confirmedInterviewTime.preferred_time
                  ? new Date(confirmedInterviewTime.preferred_time).toString()
                  : "I don’t wish to attend an interview for this role."}
                <br />
                {confirmedInterviewTime.preferred_location === "on_campus"
                  ? "Location: " + confirmedInterviewTime.campus
                  : confirmedInterviewTime.preferred_location === "online"
                  ? "Meeting Link: " + confirmedInterviewTime.meeting_link
                  : null}
              </CheckableButton>
            </div>
          ) : (
            <div className="row m-0">
              {interviewTime?.map((item) => (
                <CheckableButton
                  // id={item._id}
                  className="w-100 mb-3 pl-5 p-2"
                  checked={false}
                >
                  {item.preferred_time
                    ? new Date(item.preferred_time).toString()
                    : "I don’t wish to attend an interview for this role."}
                  <br />
                  {item.preferred_location === "on_campus"
                    ? "Location: " + item.campus
                    : item.preferred_location === "online"
                    ? "Meeting Link: " + item.meeting_link
                    : null}
                </CheckableButton>
              ))}
            </div>
          )
        ) : (
          <div className="model-main-content">
            <div className="mb-5">
              <p className="h5">
                <strong>First Preference</strong>
              </p>
              <div className="row">
                <div className="col-md-5 pr-5">
                  <label className="pb-1">Preferred Date & Time</label>
                  <DatePicker
                    id="preferredTime1"
                    showPopperArrow={false}
                    className="form-control"
                    selected={preferredTime1}
                    onChange={(date) => setPreferredTime1(date)}
                    minDate={new Date()}
                    showTimeInput
                    timeInputLabel="Time:"
                    popperModifiers={{ preventOverflow: { enabled: false } }}
                    dateFormat="yyyy-MM-dd h:mm aa"
                    required
                  />
                </div>
                <div className="col-md-7 pr-0">
                  <ButtonContainer label="Location" twoColumns>
                    <CheckableButton
                      id="location_online1"
                      title="online"
                      required
                      onChange={(e) => setPreferredLocation1(e.target.title)}
                      checked={preferredLocation1 === "online"}
                    >
                      Online
                    </CheckableButton>
                    <CheckableButton
                      id="location_on_campus1"
                      title="on_campus"
                      required
                      onChange={(e) => setPreferredLocation1(e.target.title)}
                      checked={preferredLocation1 === "on_campus"}
                    >
                      On Campus
                    </CheckableButton>
                  </ButtonContainer>
                </div>
              </div>
              {preferredLocation1 === "online" ? (
                <FormField
                  className="mr-2"
                  id="meeting_link1"
                  label="Meeting link"
                  required
                  placeholder="Please add link to meeting channel"
                  value={meetingLink1}
                  onChange={(e) => setMeetingLink1(e.target.value)}
                />
              ) : null}
              {preferredLocation1 === "on_campus" ? (
                <FormDropdown
                  label="Campus"
                  id="campus1"
                  className="col-md-5 pl-0"
                  value={campus1}
                  onChange={(e) => setCampus1(e.target.value)}
                  required
                >
                  <option value="" hidden>
                    Select from drop down
                  </option>
                  {campuses.map((campus) => {
                    return (
                      <option value={campus.campus_shortname}>
                        {campus.campus_shortname}
                      </option>
                    );
                  })}
                </FormDropdown>
              ) : null}
            </div>

            <div className="mb-5">
              <p className="h5">
                <strong>Second Preference</strong>
              </p>
              <div className="row">
                <div className="col-md-5 pr-5">
                  <label className="pb-1">Preferred Date & Time</label>
                  <DatePicker
                    id="preferredTime2"
                    showPopperArrow={false}
                    className="form-control"
                    selected={preferredTime2}
                    onChange={(date) => setPreferredTime2(date)}
                    minDate={new Date()}
                    showTimeInput
                    timeInputLabel="Time:"
                    popperModifiers={{ preventOverflow: { enabled: false } }}
                    dateFormat="yyyy-MM-dd h:mm aa"
                    required
                  />
                </div>
                <div className="col-md-7 pr-0">
                  <ButtonContainer label="Location" twoColumns>
                    <CheckableButton
                      id="location_online2"
                      title="online"
                      required
                      onChange={(e) => setPreferredLocation2(e.target.title)}
                      checked={preferredLocation2 === "online"}
                    >
                      Online
                    </CheckableButton>
                    <CheckableButton
                      id="location_on_campus2"
                      title="on_campus"
                      required
                      onChange={(e) => setPreferredLocation2(e.target.title)}
                      checked={preferredLocation2 === "on_campus"}
                    >
                      On Campus
                    </CheckableButton>
                  </ButtonContainer>
                </div>
              </div>
              {preferredLocation2 === "online" ? (
                <FormField
                  className="mr-2"
                  id="meeting_link2"
                  label="Meeting link"
                  required
                  placeholder="Please add link to meeting channel"
                  value={meetingLink2}
                  onChange={(e) => setMeetingLink2(e.target.value)}
                />
              ) : null}
              {preferredLocation2 === "on_campus" ? (
                <FormDropdown
                  label="Campus"
                  id="campus2"
                  className="col-md-5 pl-0"
                  value={campus2}
                  onChange={(e) => setCampus2(e.target.value)}
                  required
                >
                  <option value="" hidden>
                    Select from drop down
                  </option>
                  {campuses.map((campus) => {
                    return (
                      <option value={campus.campus_shortname}>
                        {campus.campus_shortname}
                      </option>
                    );
                  })}
                </FormDropdown>
              ) : null}
            </div>

            <div className="mb-5">
              <p className="h5">
                <strong>Third Preference (Optional)</strong>
              </p>
              <div className="row">
                <div className="col-md-5 pr-5">
                  <label className="pb-1">Preferred Date & Time</label>
                  <DatePicker
                    id="preferredTime3"
                    showPopperArrow={false}
                    className="form-control"
                    selected={preferredTime3}
                    onChange={(date) => setPreferredTime3(date)}
                    minDate={new Date()}
                    showTimeInput
                    timeInputLabel="Time:"
                    popperModifiers={{ preventOverflow: { enabled: false } }}
                    dateFormat="yyyy-MM-dd h:mm aa"
                  />
                </div>
                <div className="col-md-7 pr-0">
                  <ButtonContainer label="Location" twoColumns>
                    <CheckableButton
                      id="location_online3"
                      title="online"
                      onChange={(e) => setPreferredLocation3(e.target.title)}
                      checked={preferredLocation3 === "online"}
                    >
                      Online
                    </CheckableButton>
                    <CheckableButton
                      id="location_on_campus3"
                      title="on_campus"
                      onChange={(e) => setPreferredLocation3(e.target.title)}
                      checked={preferredLocation3 === "on_campus"}
                    >
                      On Campus
                    </CheckableButton>
                  </ButtonContainer>
                </div>
              </div>
              {preferredLocation3 === "online" ? (
                <FormField
                  className="mr-2"
                  id="meeting_link3"
                  label="Meeting link"
                  placeholder="Please add link to meeting channel"
                  value={meetingLink3}
                  onChange={(e) => setMeetingLink3(e.target.value)}
                />
              ) : null}
              {preferredLocation3 === "on_campus" ? (
                <FormDropdown
                  label="Campus"
                  id="campus3"
                  className="col-md-5 pl-0"
                  value={campus3}
                  onChange={(e) => setCampus3(e.target.value)}
                >
                  <option value="" hidden>
                    Select from drop down
                  </option>
                  {campuses.map((campus) => {
                    return (
                      <option value={campus.campus_shortname}>
                        {campus.campus_shortname}
                      </option>
                    );
                  })}
                </FormDropdown>
              ) : null}
            </div>

            <div className="row justify-content-center">
              <div className="col-md-6">
                <ConfirmButton
                  type="submit"
                  className="college_submit"
                  onClick={requestInterview}
                >
                  Submit
                </ConfirmButton>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    providerUser: state.college.user,
  };
}

const mapDispatchToProps = {
  addRemoveFavouriteTeacher,
  blockUnblockTeacher,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SearchCard));
